import { Avatar as MuiAvatar, AvatarProps, Chip as MuiChip, ChipProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { theme } from '../../theme/theme';

const useChipClasses = makeStyles({
    root: {
        '&.MuiChip-root': {
            background: theme.colors.neutral[4],
            ...theme.typography.content.label.default,
        },
        '& .MuiChip-icon': {
            color: theme.colors.darkBlue[1],
        },
        '& .MuiChip-deleteIcon': {
            // TODO color not defined
            color: '#54677A',
        },
    },
});

/**
 * Themed material-ui chip.
 */
export const Chip = (props: ChipProps) => {
    const classes = useChipClasses();

    return <MuiChip {...props} className={clsx(classes.root, props.classes?.root)} />;
};

const useAvatarClasses = makeStyles({
    root: {
        color: `${theme.colors.white} !important`,
        background: theme.colors.darkBlue[2],
        ...theme.typography.headings.h5,
        marginBottom: 0,
        textTransform: 'uppercase',
    },
});

/**
 * Extension of the material-ui avatar component with defined style.
 *
 * @param props.name avatar name use to compute initials
 */
export const Avatar = (props: AvatarProps & { name?: string }) => {
    const { name, ...rootProps } = props;
    const classes = useAvatarClasses();
    return (
        <MuiAvatar
            {...rootProps}
            className={clsx(classes.root, rootProps.className)}
            src={rootProps.src === '' ? undefined : rootProps.src}
            alt={props.alt ?? props.name}
        >
            {(props.src == undefined || props.src === '') &&
                props.name != undefined &&
                props.name
                    .split(' ')
                    .map(part => part[0])
                    .join('')
                    .slice(0, 2)}
        </MuiAvatar>
    );
};
